import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import NoDeviceButton from '../NoDeviceButton';
import styles from '../../DeviceLinks.module.css';
import Form from 'react-bootstrap/Form';
import { Field, FormikProvider } from 'formik';
import { Button, ValidatedPhoneNumber } from 'ui';
import { setButtonVariant } from 'utils/utilities';
import { useResendCountdown } from 'features/common/hooks';
import useMessageForm from './useMessageForm';

const Message = ({ theme, navigate, isReauthenticate, stopPolling, sentAt, onSent }) => {
    const { formik } = useMessageForm({ isReauthenticate, onSent });
    const { handleSubmit, isSubmitting } = formik;

    const { active: success, secs } = useResendCountdown(sentAt);

    return (
        <FormikProvider value={formik}>
            <Form noValidate onSubmit={handleSubmit}>
                <Card.Body style={{ padding: '24px 0px 0px' }} className={styles.body}>
                    <div>
                        <h4 className={styles.PassportCardHeading}>
                            {success
                                ? 'Successfully sent a link on your phone'
                                : 'Receive a link on your phone'}
                        </h4>
                        <p className={styles.PassportCardSubheading}>
                            {success
                                ? 'Please open the link we have sent on your mobile device'
                                : 'Enter your mobile phone number and we will send you a link to complete this verification on your mobile device.'}
                        </p>
                        {success ? (
                            <span className="text-muted" style={{ fontSize: '12px' }}>
                                {`You can again retry in ${secs} seconds`}
                            </span>
                        ) : (
                            <Field
                                name="phoneNumber"
                                component={ValidatedPhoneNumber}
                                label="Phone Number"
                                className={styles.phoneNumber}
                            />
                        )}
                    </div>
                </Card.Body>
                <Card.Footer
                    style={{
                        padding: '35px 0px 0px',
                        border: 'none',
                        background: 'none',
                    }}
                >
                    <Button
                        className={styles.passportFooterBtn}
                        block
                        disabled={success || isSubmitting}
                        variant={setButtonVariant(theme?.button?.variant)}
                        type="submit"
                    >
                        Send Link
                    </Button>
                    {!isReauthenticate && (
                        <NoDeviceButton navigate={navigate} stopPolling={stopPolling} />
                    )}
                </Card.Footer>
            </Form>
        </FormikProvider>
    );
};

Message.propTypes = {
    theme: PropTypes.object,
    navigate: PropTypes.func,
    isReauthenticate: PropTypes.bool,
    stopPolling: PropTypes.func,
    sentAt: PropTypes.number,
    onSent: PropTypes.func,
};

export default Message;
